import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { currentAuthToken, currentUser } from '../auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { HttpUtilsService } from '../_base/crud';
import { environment } from '../../../environments/environment';

@Injectable()
export class TwixorService {
  private authToken;
  private companyId;
  private twixorToken;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => {
      this.companyId = res.companyID;
    });
    this.twixorToken = localStorage.getItem('twixor_token');
  }

  getDepartments() {
    const url = environment.USER_BASE + `/companies/${this.companyId}/twixor/departments`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers });
  }

  syncUsersToTwixor() {
    const url = environment.USER_BASE + `/companies/${this.companyId}/twixor/sync-users`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, null, { headers });
  }

  loginToTwixor() {
    const url = environment.USER_BASE + `/twixor/login`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, null, { headers });
  }

  logoutFromTwixor() {
    const url = environment.USER_BASE + `/twixor/logout`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers });
  }

  onlineOffline(status) {
    const url = environment.USER_BASE + `/twixor/change-status`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<any>(url, { status }, { headers });
  }
}
